import { IToingPriceComparisonBEData, PC_HALFCARD_STATES } from "@swiggy-private/cart-types";
import { isEmpty } from "@swiggy-private/js-utils";
import {
    UPLOAD_BUTTON_BG_PRIMARY,
    UPLOAD_BUTTON_BG_SECONDARY,
    UPLOAD_BUTTON_LABEL_AGAIN,
    UPLOAD_BUTTON_LABEL_BILL,
} from "./constants";

export interface IUploaderButtonAppearance {
    text: string;
    bg: string;
}

export const hasUploadRejectionCta = (priceComparisonData?: IToingPriceComparisonBEData): boolean => {
    const rejection = priceComparisonData?.rejection_state_halfcard_data;
    return (
        !isEmpty(rejection) &&
        !isEmpty(rejection?.cta?.icon) &&
        Boolean(rejection?.cta?.text?.toLowerCase().includes("upload"))
    );
};

export const shouldShowImageUploader = (
    comparisonState: PC_HALFCARD_STATES,
    priceComparisonData?: IToingPriceComparisonBEData,
): boolean =>
    comparisonState === PC_HALFCARD_STATES.INSTRUCTIONS ||
    comparisonState === PC_HALFCARD_STATES.IMAGE_TOO_LARGE_ERROR ||
    (comparisonState === PC_HALFCARD_STATES.SUCCESS && hasUploadRejectionCta(priceComparisonData));

export const shouldShowBottomActions = (
    comparisonState: PC_HALFCARD_STATES,
    priceComparisonData?: IToingPriceComparisonBEData,
): boolean =>
    comparisonState !== PC_HALFCARD_STATES.SCANNING &&
    comparisonState !== PC_HALFCARD_STATES.UPLOAD_IMAGE &&
    !(comparisonState === PC_HALFCARD_STATES.SUCCESS && !isEmpty(priceComparisonData?.success_state_halfcard_data));

export const getUploaderButtonAppearance = (
    comparisonState: PC_HALFCARD_STATES,
    priceComparisonData?: IToingPriceComparisonBEData,
): IUploaderButtonAppearance | undefined => {
    if (comparisonState === PC_HALFCARD_STATES.INSTRUCTIONS) {
        return { text: UPLOAD_BUTTON_LABEL_BILL, bg: UPLOAD_BUTTON_BG_PRIMARY };
    }
    if (comparisonState === PC_HALFCARD_STATES.IMAGE_TOO_LARGE_ERROR) {
        return { text: UPLOAD_BUTTON_LABEL_AGAIN, bg: UPLOAD_BUTTON_BG_SECONDARY };
    }
    if (comparisonState === PC_HALFCARD_STATES.SUCCESS && hasUploadRejectionCta(priceComparisonData)) {
        return { text: UPLOAD_BUTTON_LABEL_AGAIN, bg: UPLOAD_BUTTON_BG_SECONDARY };
    }
    return undefined;
};
